module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Medium.d815b0a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat/Montserrat-Medium.otf
// module id = 603
// module chunks = 4